import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

// Page components (direct import for critical pages)
import LeeGuitarsApp from './../components/pages/pc/index/lee'
import Index from './../components/pages/pc/index/index'

// Lazy-loaded Monitor components
const Test = lazy(() => import('./../components/pages/pc/test/index'))
const Dstyle = lazy(() => import('./../components/pages/pc/mi_temp_rh_monitor/Dstyle'))
const Dspecifications = lazy(() => import('./../components/pages/pc/mi_temp_rh_monitor/Dspecifications'))
const Gstyle = lazy(() => import('./../components/pages/pc/cg_temp_rh_monitor/Gstyle'))
const Gspecifications = lazy(() => import('./../components/pages/pc/cg_temp_rh_monitor/Gspecifications'))
const Lstyle = lazy(() => import('./../components/pages/pc/lee_temp_rh_monitor/Lstyle'))
const Lspecifications = lazy(() => import('./../components/pages/pc/lee_temp_rh_monitor/Lspecifications'))
const privacy = lazy(() => import('./../components/pages/pc/privacy'))
const Bprivacy = lazy(() => import('./../components/pages/pc/Bprivacy'))
const Air = lazy(() => import('./../components/pages/pc/air'))
const QingpingPlus = lazy(() => import('./../components/pages/pc/qingping_plus'))
const Pstyle = lazy(() => import('./../components/pages/pc/lora_temp_rh_monitor/Pstyle'))
const Cstyle = lazy(() => import('./../components/pages/pc/co2_temp_rh_monitor/Pstyle'))
const GeckoStyle = lazy(() => import('./../components/pages/pc/gecko_wall/overview'))
const GeckoSpecifications = lazy(() => import('./../components/pages/pc/gecko_wall/specifications'))
const Pspecifications = lazy(() => import('./../components/pages/pc/lora_temp_rh_monitor/Pspecifications'))
const Cspecifications = lazy(() => import('./../components/pages/pc/co2_temp_rh_monitor/Pspecifications'))
const Fstyle = lazy(() => import('./../components/pages/pc/frog/Pstyle'))
const Fspecifications = lazy(() => import('./../components/pages/pc/frog/Pspecifications'))

// Air Monitor components
const Sstyle = lazy(() => import('./../components/pages/pc/air_monitor/Sstyle'))
const Sspecifications = lazy(() => import('./../components/pages/pc/air_monitor/Sspecifications'))
const Snowprostyle = lazy(() => import('./../components/pages/pc/snowpro/overview'))
const Snowprospecifications = lazy(() => import('./../components/pages/pc/snowpro/specifications'))
// Device-specific components
const Danystyle = lazy(() => import('./../components/pages/pc/air_monitor_lite/Sstyle'))
const Danyspecifications = lazy(() => import('./../components/pages/pc/air_monitor_lite/Sspecifications'))
const Dk2style = lazy(() => import('./../components/pages/pc/temp_rh_monitor_lite/Sstyle'))
const Dk2specifications = lazy(() => import('./../components/pages/pc/temp_rh_monitor_lite/Sspecifications'))
const Dk3style = lazy(() => import('../components/pages/pc/duck3/index'))
const Dk3specifications = lazy(() => import('./../components/pages/pc/duck3/Sspecifications'))
const Hodorstyle = lazy(() => import('./../components/pages/pc/hodor/Sstyle'))
const Hodorspecifications = lazy(() => import('./../components/pages/pc/hodor/Sspecifications'))
const Parrotstyle = lazy(() => import('./../components/pages/pc/parrot/Sstyle'))
const Parrotspecifications = lazy(() => import('./../components/pages/pc/parrot/Sspecifications'))
const Chickenstyle = lazy(() => import('./../components/pages/pc/chicken/Sstyle'))
const Chickenspecifications = lazy(() => import('./../components/pages/pc/chicken/Sspecifications'))
// Utility pages
const Bran = lazy(() => import('./../components/pages/pc/mi_air_monitor'))
// const Store = lazy(() => import('./../components/pages/pc/store'))
const AllPrivacy = lazy(() => import('./../components/pages/pc/all_privacy'))
const AboutUs = lazy(() => import('./../components/pages/pc/about_us'))
const PresetApps = lazy(() => import('./../components/pages/pc/preset_apps'))
const qingpingiot = lazy(() => import('./../components/pages/pc/qing_ping_iot'))
const Spstyle = lazy(() => import('./../components/pages/pc/sparrow/Overview'))
const Spspecifications = lazy(() => import('./../components/pages/pc/sparrow/Specifications'))
const doveOverview = lazy(() => import('./../components/pages/pc/dove/overview'))
const doveSpecifications = lazy(() => import('./../components/pages/pc/dove/specifications'))
const Clock = lazy(() => import('./../components/pages/pc/bluetooth_alarm_clock'))
// Shared components
const Share = lazy(() => import('./../components/pages/m2p/share'))
const ContactUs = lazy(() => import('./../components/pages/m2p/contact'))

// Privacy components
const AirPrivacy = lazy(() => import('./../components/pages/mobile/air_privacy'))
const LeeGuitarsPrivacy = lazy(() => import('./../components/pages/mobile/lee_guitars_privacy'))
const iotPrivacy = lazy(() => import('./../components/pages/mobile/iot_privacy'))
const iotWebsitePrivacy = lazy(() => import('./../components/pages/mobile/iot_website_privacy'))
const AirAgreement = lazy(() => import('./../components/pages/m2p/air_agreement'))
const GPrivacy = lazy(() => import('./../components/pages/m2p/Gprivacy'))
const SPrivacy = lazy(() => import('./../components/pages/m2p/Sprivacy'))
const HPrivacy = lazy(() => import('./../components/pages/m2p/Hprivacy'))
const PPrivacy = lazy(() => import('./../components/pages/m2p/Pprivacy'))
const DNprivacy = lazy(() => import('./../components/pages/m2p/DanyPrivacy'))
const DPrivacy = lazy(() => import('./../components/pages/m2p/Dprivacy'))
const DovePrivacy = lazy(() => import('./../components/pages/m2p/DovePrivacy'))
const SnowPrivacy = lazy(() => import('./../components/pages/m2p/SnowPrivacy'))
const ChickenPrivacy = lazy(() => import('./../components/pages/m2p/ChickenPrivacy'))
// Translator and Documentation
const MiTranslator = lazy(() => import('./../components/pages/pc/mi_translator'))

// EU Documentation
const EuDoc = lazy(() => import('./../components/pages/pc/eu_doc'))
const MagpieEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/magpie'))
const DanyEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/dany'))
const ChickenEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/chicken'))
const DoveEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/dove'))
const SparrowEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/sparrow'))
const HodorEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/hodor'))
const ParrotEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/parrot'))
const GooseHEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/goose_h'))
const Duck2EuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/duck2'))
const Duck2CEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/duck2_c'))
const GooseMEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/goose_m'))
const FrogEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/frog'))
const SnowEuDoc = lazy(() => import('./../components/pages/pc/eu_doc_pages/snow'))

// Additional components
const Goose3style = lazy(() => import('../components/pages/pc/goose3/index'))
const Goose3specifications = lazy(() => import('../components/pages/pc/goose3/Sspecifications'))
const Comparison = lazy(() => import('../components/pages/pc/comparison/humiture'))
const ComparisonAir = lazy(() => import('../components/pages/pc/comparison/air'))
const Frogs = lazy(() => import('../components/pages/pc/frogs'))
const FrogsSpecifications = lazy(() => import('../components/pages/pc/frogs/ForgsSpecifications'))
const Robb = lazy(() => import('../components/pages/pc/robb'))
const RobbSpecifications = lazy(() => import('../components/pages/pc/robb/robbSpecifications'))


const redirectRoutes = [
  { path: '/store', to: '/'},
  { path: '/plus', to: '/home-app' },
  { path: '/plus/privacy', to: '/home-app/privacy' },
  { path: '/mi-temp-rh-monitor', to: '/mi-temp-rh-monitor/overview' },
  { path: '/temp-rh-monitor-t', to: '/temp-rh-monitor/overview' },
  { path: '/lee-guitars-thermo-hygrometer', to: '/lee-guitars-thermo-hygrometer/overview' },
  { path: '/mi-multifunction-air-monitor', to: '/mi-multifunction-air-monitor/privacy' },
  { path: '/apps', to: '/apps/qingpingplus' },
  { path: '/temp-rh-monitor-pro-s', to: '/temp-rh-monitor-pro-s/overview' },
  { path: '/temp-rh-monitor-pro-e', to: '/temp-rh-monitor-pro-e/overview' },
  { path: '/air-monitor', to: '/air-monitor/overview' },
  { path: '/air-monitor-lite', to: '/air-monitor-lite/overview' },
  { path: '/temp-rh-monitor-lite', to: '/temp-rh-monitor-lite-3/overview' },
  { path: '/temp-rh-monitor', to: '/temp-rh-monitor/overview' },
  { path: '/bluetooth-gateway', to: '/bluetooth-gateway/overview' },
  { path: '/bluetooth-alarm-clock', to: '/bluetooth-alarm-clock/overview' },
  { path: '/indoor-environment-monitor', to: '/indoor-environment-monitor/overview' },
  { path: '/mi-translator', to: '/mi-translator/preset-apps' },
  { path: '/lee-guitars/app', to: '/lee-guitars/app/overview' },
  { path: '/co2-temp-rh-monitor', to: '/co2-temp-rh-monitor/overview' },
  { path: '/wall-socket-thermometer', to: '/wall-socket-thermometer/overview' },
  { path: '/temp-rh-monitor-lite-3', to: '/temp-rh-monitor-lite-3/overview' },
  { path: '/temp-rh-monitor-3', to: '/temp-rh-monitor-3/overview' },
  { path: '/door-window-sensor', to: '/door-window-sensor/overview' },
  { path: '/motion-light-sensor', to: '/motion-light-sensor/overview' },
  { path: '/bluetooth-clock', to: '/bluetooth-clock/overview' },
  { path: '/bluetooth-gateway', to: '/bluetooth-gateway/overview' },
  { path: '/multi-role-monitor', to: '/multi-role-monitor/overview' }
]

const routeConfigs = [
  { path: '/lee-guitars/app/overview', exact: true, component: LeeGuitarsApp },
  { path: '/', exact: true, component: Index },
  { path: '/Test', exact: true, component: Test },
  { path: '/mi-temp-rh-monitor/overview', exact: true, component: Dstyle },
  { path: '/mi-temp-rh-monitor/specifications', exact: true, component: Dspecifications },
  { path: '/temp-rh-monitor/overview', exact: true, component: Gstyle },
  { path: '/temp-rh-monitor/specifications', exact: true, component: Gspecifications },
  { path: '/lee-guitars-thermo-hygrometer/overview', exact: true, component: Lstyle },
  { path: '/lee-guitars-thermo-hygrometer/specifications', exact: true, component: Lspecifications },
  { path: '/mi-temp-rh-monitor/privacy', exact: true, component: privacy },
  { path: '/mi-multifunction-air-monitor/privacy', exact: true, component: Bprivacy },
  { path: '/home-app', exact: true, component: Air },
  { path: '/apps/qingpingplus', exact: true, component: QingpingPlus },
  { path: '/air', exact: true, component: Air },
  { path: '/temp-rh-monitor-pro-s/overview', exact: true, component: Pstyle },
  { path: '/co2-temp-rh-monitor/overview', exact: true, component: Cstyle },
  { path: '/wall-socket-thermometer/overview', exact: true, component: GeckoStyle },
  { path: '/wall-socket-thermometer/specifications', exact: true, component: GeckoSpecifications },
  { path: '/temp-rh-monitor-pro-s/specifications', exact: true, component: Pspecifications },
  { path: '/co2-temp-rh-monitor/specifications', exact: true, component: Cspecifications },
  { path: '/temp-rh-monitor-pro-e/overview', exact: true, component: Fstyle },
  { path: '/temp-rh-monitor-pro-e/specifications', exact: true, component: Fspecifications },
  { path: '/air-monitor/overview', exact: true, component: Sstyle },
  { path: '/air-monitor/specifications', exact: true, component: Sspecifications },
  { path: '/air-monitor-2/overview', exact: true, component: Snowprostyle },
  { path: '/air-monitor-2/specifications', exact: true, component: Snowprospecifications },
  { path: '/air-monitor-lite/overview', exact: true, component: Danystyle },
  { path: '/air-monitor-lite/specifications', exact: true, component: Danyspecifications },
  { path: '/temp-rh-monitor-lite/overview', exact: true, component: Dk2style },
  { path: '/temp-rh-monitor-lite/specifications', exact: true, component: Dk2specifications },
  { path: '/temp-rh-monitor-lite-3/overview', exact: true, component: Dk3style },
  { path: '/temp-rh-monitor-lite-3/specifications', exact: true, component: Dk3specifications },
  { path: '/temp-rh-monitor-3/overview', exact: true, component: Goose3style },
  { path: '/temp-rh-monitor-3/specifications', exact: true, component: Goose3specifications },
  { path: '/door-window-sensor/overview', exact: true, component: Hodorstyle },
  { path: '/door-window-sensor/specifications', exact: true, component: Hodorspecifications },
  { path: '/motion-light-sensor/overview', exact: true, component: Parrotstyle },
  { path: '/motion-light-sensor/specifications', exact: true, component: Parrotspecifications },
  { path: '/bluetooth-clock/overview', exact: true, component: Chickenstyle },
  { path: '/bluetooth-clock/specifications', exact: true, component: Chickenspecifications },
  { path: '/mi-air-monitor', exact: true, component: Bran },
  // { path: '/store', exact: true, component: Store },
  { path: '/privacy', exact: true, component: AllPrivacy },
  { path: '/about-us', exact: true, component: AboutUs },
  { path: '/iot', exact: true, component: qingpingiot },
  { path: '/qingpingiot', exact: true, component: qingpingiot },
  { path: '/mi-translator/preset-apps', exact: true, component: PresetApps },
  { path: '/bluetooth-gateway/overview', exact: true, component: Spstyle },
  { path: '/bluetooth-gateway/specifications', exact: true, component: Spspecifications },
  { path: '/bluetooth-alarm-clock/overview', exact: true, component: doveOverview },
  { path: '/bluetooth-alarm-clock/specifications', exact: true, component: doveSpecifications },
  { path: '/bluetooth-alarm-clock/apps', exact: true, component: Clock },
  { path: '/air-app-and-temp-rh-monitor', exact: true, component: Share },
  { path: '/air-app-and-temp-rh-barometer', exact: true, component: Share },
  { path: '/contact', exact: true, component: ContactUs },
  { path: '/air/privacy', exact: true, component: AirPrivacy },
  { path: '/lee-guitars/privacy', exact: true, component: LeeGuitarsPrivacy },
  { path: '/iot/privacy', exact: true, component: iotPrivacy },
  { path: '/iot-website/privacy', exact: true, component: iotWebsitePrivacy },
  { path: '/home-app/privacy', exact: true, component: AirPrivacy },
  { path: '/air/agreement', exact: true, component: AirAgreement },
  { path: '/temp-rh-monitor/privacy', exact: true, component: GPrivacy },
  { path: '/bluetooth-gateway/privacy', exact: true, component: SPrivacy },
  { path: '/door-window-sensor/privacy', exact: true, component: HPrivacy },
  { path: '/motion-light-sensor/privacy', exact: true, component: PPrivacy },
  { path: '/air-monitor-lite/privacy', exact: true, component: DNprivacy },
  { path: '/temp-rh-monitor-lite/privacy', exact: true, component: DPrivacy },
  { path: '/duck3/privacy', exact: true, component: DPrivacy },
  { path: '/alarm-clock/privacy', exact: true, component: DovePrivacy },
  { path: '/bluetooth-clock/privacy', exact: true, component: ChickenPrivacy },
  { path: '/air-monitor/privacy', exact: true, component: SnowPrivacy },
  { path: '/mi_translator/preset_apps', exact: true, component: MiTranslator },
  { path: '/eu-declarations', exact: true, component: EuDoc },
  { path: '/lee-guitars-thermo-hygrometer/eu-declaration', exact: true, component: MagpieEuDoc },
  { path: '/air-monitor-lite/eu-declaration', exact: true, component: DanyEuDoc },
  { path: '/bluetooth-clock/eu-declaration', exact: true, component: ChickenEuDoc },
  { path: '/bluetooth-alarm-clock/eu-declaration', exact: true, component: DoveEuDoc },
  { path: '/bluetooth-gateway/eu-declaration', exact: true, component: SparrowEuDoc },
  { path: '/door-window-sensor/eu-declaration', exact: true, component: HodorEuDoc },
  { path: '/motion-light-sensor/eu-declaration', exact: true, component: ParrotEuDoc },
  { path: '/temp-rh-monitor-h/eu-declaration', exact: true, component: GooseHEuDoc },
  { path: '/temp-rh-monitor-lite/eu-declaration', exact: true, component: Duck2EuDoc },
  { path: '/temp-rh-monitor-lite-c/eu-declaration', exact: true, component: Duck2CEuDoc },
  { path: '/temp-rh-monitor/eu-declaration', exact: true, component: GooseMEuDoc },
  { path: '/temp-rh-monitor-pro-e/eu-declaration', exact: true, component: FrogEuDoc },
  { path: '/air-monitor/eu-declaration', exact: true, component: SnowEuDoc },
  { path: '/multi-role-monitor/overview', exact: true, component: Frogs },
  { path: '/multi-role-monitor/specifications', exact: true, component: FrogsSpecifications },
  { path: '/indoor-environment-monitor/overview', exact: true, component: Robb },
  { path: '/indoor-environment-monitor/specifications', exact: true, component: RobbSpecifications },
  { path: '/comparison-temp-rh-monitor', exact: true, component: Comparison },
  { path: '/comparison-air-monitor', exact: true, component: ComparisonAir }
]
const Routers = () => (
  <Suspense fallback={<div></div>}>
    <Switch>
      {redirectRoutes.map(({ path, to }) => (
        <Route key={`redirect:${path}`} path={path} exact render={() => <Redirect to={to} />}></Route>
      ))}
      {routeConfigs.map(({ path, exact, component }) => (
        <Route key={path} path={path} exact={!!exact} component={component} />
      ))}
    </Switch>
  </Suspense>
)

export default Routers
